import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import Layout from "../layout/layout";
export default class Contact extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let NavList = [
            { Text: 'Contact Us', Link: '' }
        ];
        return (React.createElement(Layout, null,
            React.createElement("div", { className: "contact-us" },
                React.createElement(Breadcrumb, { NavList: NavList }),
                React.createElement("h5", null, "HOW CAN WE HELP"),
                React.createElement("h1", null, "CONTACT US"),
                React.createElement("div", { className: "contact-content" },
                    React.createElement("div", { className: "contact-section" },
                        React.createElement("div", null,
                            React.createElement("h3", null, "CUSTOMER SERVICE")),
                        React.createElement("div", { className: "customer-service" },
                            React.createElement("div", null,
                                React.createElement("p", null, "Phone: 780-418-6500"),
                                React.createElement("p", null, "Phone: 1-800-265-6784")),
                            React.createElement("div", { className: "table" },
                                React.createElement("div", { className: "table-row" },
                                    React.createElement("div", { className: "table-cell" }, "Monday to Friday"),
                                    React.createElement("div", { className: "table-cell" }, "8:00AM \u2013 4:30PM")),
                                React.createElement("div", { className: "table-row" },
                                    React.createElement("div", { className: "table-cell" }, "Sunday"),
                                    React.createElement("div", { className: "table-cell" }, "8:00AM \u2013 3:30PM")),
                                React.createElement("div", { className: "table-row" },
                                    React.createElement("div", { className: "table-cell" }, "Statutory Holidays"),
                                    React.createElement("div", { className: "table-cell" }, "8:00AM \u2013 3:30PM")),
                                React.createElement("div", { className: "table-row" },
                                    React.createElement("div", { className: "table-cell" }, "Christmas and New Year's Day"),
                                    React.createElement("div", { className: "table-cell" }, "Closed"))))),
                    React.createElement("div", { className: "contact-section" },
                        React.createElement("div", null,
                            React.createElement("h3", null, "HEAD OFFICE")),
                        React.createElement("div", null,
                            React.createElement("p", null, "Connect Logistics Services"),
                            React.createElement("p", null, "1 - 2 Boudreau Rd"),
                            React.createElement("p", null, "St. Albert, Alberta"),
                            React.createElement("p", null, "Canada, T8N 6K3")))))));
    }
}
;
//# sourceMappingURL=contact.js.map